var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('b-card',[_c('b-card-title',[_vm._v(" Session Logging Out ")]),_c('b-card-text',[_vm._v(" You have been idle for a while. You will be logged out in "+_vm._s(_vm.countdown)+" seconds. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }